import cardResource from "@/shared/resource/card";
import { authorizedAxios } from "./authorizedAxios";
import {
  CreateCardIssueCriteriaRequest,
  DependentRequest,
  FiservDebitCardInfo,
  FiservDebitCardListResponse,
  SetCardPinRequest } from "@/shared/types";
import { PartnerCardAllowList } from "@/admin/types";

export function getFiservDebitCards () {
  return authorizedAxios.get<FiservDebitCardListResponse>(cardResource.fiservDebitCards());
}
export function setFiservDebitCardPIN (fiservUserInfoId: number, setCardPinRequest: SetCardPinRequest) {
  return authorizedAxios.post(cardResource.setFiservDebitCardPIN(fiservUserInfoId), setCardPinRequest);
}
export function addFiservDebitCardDependent (dependentRequest: DependentRequest) {
  return authorizedAxios.post(cardResource.addFiservDebitCardDependent(), dependentRequest);
}
export function deativateFiservDebitCard (fiservUserInfoId: number) {
  return authorizedAxios.post(cardResource.deativateFiservDebitCard(fiservUserInfoId));
}
export function replaceFiservDebitCard (fiservUserInfoId: number) {
  return authorizedAxios.post(cardResource.replaceFiservDebitCard(fiservUserInfoId));
}
export function confirmReplacementFiservDebitCard (fiservUserInfoId: number) {
  return authorizedAxios.post(cardResource.confirmReplacementFiservDebitCard(fiservUserInfoId));
}
export function getPartnerIssueCriterias (partnerId: number) {
  return authorizedAxios.get<PartnerCardAllowList>(cardResource.partnerCardIssueCriterias(partnerId));
}
export function deleteCardIssueCriterias (id: number) {
  return authorizedAxios.delete(cardResource.deleteCardIssueCriterias(id));
}
export function createCardIssueCriteria (request: CreateCardIssueCriteriaRequest) {
  return authorizedAxios.post(cardResource.createCardIssueCriteria(), request);
}